import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { isTabWidth } from "../data/database";

const Card = ({
  image,
  name,
  role,
  expertise,
  nameTextSize = "1.5rem",
  subTextSize = "0.75rem",
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        aspectRatio: "1/1",
        position: "relative",
        borderRadius: "1rem",
        overflow: "hidden",
        cursor: "pointer",
        transition: "transform 0.3s ease",
        "&:hover img": {
          transform: "scale(1.1)", // Scale image up 20%
          filter: "blur(2px)", // Frosty blur effect
          opacity: 0.5, // Darken for better contrast with the text
        },
        "&:hover .hover-text": {
          opacity: 1, // Show text on hover
        },
      }}
    >
      <img
        src={image}
        alt={name}
        style={{
          width: "100%",
          objectFit: "cover",
          transition:
            "transform 0.3s ease, filter 0.3s ease, opacity 0.3s ease",
        }}
      />
      <Box
        className="hover-text"
        sx={{
          position: "absolute",
          bottom: "1rem",
          left: "1rem",
          color: "black",
          right: "1rem",
          opacity: 0, // Hidden until hover
          transition: "opacity 0.3s ease",
        }}
      >
        <h1
          style={{
            fontSize: nameTextSize,
            fontWeight: "500",
            marginBottom: "0.25rem",
          }}
        >
          {name}
        </h1>
        <p
          style={{
            fontSize: subTextSize,
            fontWeight: "600",
            marginTop: 0,
            marginBottom: 0,
          }}
        >
          {role}
        </p>
        <p
          style={{
            fontSize: subTextSize,
            fontWeight: "200",
            marginTop: 0,
            marginBottom: 0,
          }}
        >
          {expertise}
        </p>
      </Box>
    </Box>
  );
};
const ProfileCard = ({
  data,
  gridTemplateColumns = `repeat(${data.length}, 1fr)`,
  nameTextSize,
  subTextSize,
  gap,
}) => {
  const isTab = useMediaQuery(isTabWidth);
  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: gridTemplateColumns,
        gap: gap,
        paddingTop: "2.5rem",
        paddingBottom: "2.5rem",
      }}
    >
      {data.map((item, index) => (
        <Card
          key={index}
          image={item.image}
          name={item.name}
          role={item.role}
          expertise={item.expertise}
          nameTextSize={nameTextSize}
          subTextSize={subTextSize}
        />
      ))}
    </Box>
  );
};

export default ProfileCard;
